import { TTBackboneView } from '@/views/TTBackboneView';
import { RecruitmentPortalNavigation } from '@/portal/recruitment/RecruitmentPortalNavigation';

export class PortalJobVacancyRowController extends TTBackboneView {
	constructor( options = {} ) {
		_.defaults( options, {} );

		super( options );
	}

	initialize( options ) {
		super.initialize( options );
		var $this = this;
		var row = Global.loadWidget( 'views/portal/hr/recruitment/PortalJobVacancyRow.html' );
		for ( var key in this.model.attributes ) {
			if ( this.model.get( key ) == false ) {
				this.model.set( key, '' );
			}
		}
		this.model.set( 'is_new', this.isNewVacancy() );
		this.model.set( 'detail_url', this.getJobVacancyDetailURL() );
		this.setElement( _.template( row )( this.model.toJSON() ) );
		this.$el.on( 'click', function( e ) {
			if ( e.ctrlKey || e.metaKey || e.shiftKey || e.which === 2 ) {
				return true;
			}

			e.preventDefault();
			$this.goJobVacancyDetail();
		} );
	}

	// Normalize API/browser-cache variations so only explicit true values render the New badge.
	isNewVacancy() {
		var is_new = this.model.get( 'is_new' );

		return ( is_new === true || is_new === 1 || is_new === '1' || is_new === 'true' || is_new === 'TRUE' );
	}

	getJobVacancyDetailURL() {
		return RecruitmentPortalNavigation.getPortalViewURL( 'PortalJobVacancyDetail', { id: this.model.id } );
	}

	goJobVacancyDetail() {
		RecruitmentPortalNavigation.goToPortalView( 'PortalJobVacancyDetail', { id: this.model.id } );
	}
}
